import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    frequency = require('@blade-sxp/data-mining/assets/images/frequency.svg');
    companions = require('@blade-sxp/data-mining/assets/images/companions.svg');
    cardList = [
        {
            id: 'frequency',
            name: this.$t('frequency'),
            routerName: 'frequency',
            path: '/dataMining/bigData',
            code: '11',
            img: this.frequency,
        },
        {
            id: 'companions',
            name: this.$t('companions'),
            routerName: 'companions',
            path: '/dataMining/companions',
            code: '11',
            img: this.companions,
        },
    ];
    handleJump(path) {
        this.$router.push({ path });
    }
};
default_1 = __decorate([
    Component({
        name: 'mining',
        components: { AuthItem },
        i18n: {
            messages: {
                en: {
                    frequency: 'Frequency Analysis',
                    companions: 'Companions Analysis',
                },
                zh: {
                    frequency: '频率分析',
                    companions: '同行人分析',
                },
            },
        },
    })
], default_1);
export default default_1;
